export const GOOGLE_MAP_API_KEY = 'AIzaSyCSA20n_Qcml52_8AFUe4nTp8J8LntQzh0';
export const GEOCODING_KEY = 'AIzaSyB3fcBek2mxN9CJu6-QtHQhbG6E0ZMFrqw';

export const DEFAULT_MAP_LATITUDE = 14.554592;
export const DEFAULT_MAP_LONGITUDE = 121.0156803;
export const DEFAULT_MAP_ZOOM = 11;

export const PROPERTY_PAGE_MARKER_ICON = '//hoppler-inc.imgix.net/hoppler/pages/static/96x96.png';